const translations = {
  en_GB: {
    EMAIL: 'Email',
    PASSWORD: 'Password',
    REMEMBER_ME: 'Remember me',
    LOGIN: 'Login',
    CONFIRM_NEW_PASSWORD: 'Confirm New Password',
    RESET_PASSWORD: 'Reset Password',
    PASSWORD_CONFIRM_MESSAGE: 'Passwords must match',
    PASSWORD_VALIDATION_MESSAGE: 'Must contain 8 or more characters with a mix of upper & lower case letters, numbers & symbols and no spaces',
    REQUEST_PASSWORD_RESET: 'Request Password Reset'
  },
  en_US: {},
  fr_FR: {
    EMAIL: 'Courriel',
    PASSWORD: 'Mot de Passe',
    REMEMBER_ME: 'Se rappeler de moi',
    CONFIRM_NEW_PASSWORD: 'Confirmer votre Mot de Passe',
    RESET_PASSWORD: 'Ré-initialiser le Mot de Passe',
    PASSWORD_CONFIRM_MESSAGE: 'Les Mots de Passe doivent être identiques',
    PASSWORD_VALIDATION_MESSAGE: 'Doit contenir au minimum 8 caractères avec un mélange de minuscules et majuscules, nombres et symboles sans espaces',
    REQUEST_PASSWORD_RESET: 'demande de ré-initialisation de votre Mot de Passe'
  },
  it_IT: {
    REMEMBER_ME: 'Ricordami',
    CONFIRM_NEW_PASSWORD: 'Conferma la nuova password',
    RESET_PASSWORD: 'Reimpostare la password',
    PASSWORD_CONFIRM_MESSAGE: 'La password deve corrispondere',
    PASSWORD_VALIDATION_MESSAGE: 'Deve contenere 8 o più caratteri con un mix di lettere maiuscole e minuscole, numeri e simboli e senza spazi',
    REQUEST_PASSWORD_RESET: 'Richiedi la reimpostazione della password'
  },
  de_DE: {
    EMAIL: 'Email-Adresse',
    PASSWORD: 'Passwort',
    REMEMBER_ME: 'Merken',
    LOGIN: 'Anmelden',
    CONFIRM_NEW_PASSWORD: 'Passwort bestätigen',
    RESET_PASSWORD: 'Passwort zurücksetzen',
    PASSWORD_CONFIRM_MESSAGE: 'Passwörter nicht identisch',
    PASSWORD_VALIDATION_MESSAGE: 'Muss 8 oder mehr Zeichen bestehend aus Groß- und Kleinbuchstaben, Zahlen und Symbolen und ohne Leerzeichen enthalten',
    REQUEST_PASSWORD_RESET: 'Passwort zurücksetzen'
  }
};
export default translations;
//# sourceMappingURL=translations.js.map